(() => {
  if(window.spotecSearchTitleLoaded)return;
  window.spotecSearchTitleLoaded=true;
  const compile=value=>{
    const q=String(value||'').trim();
    // Keep deliberate Shopify field syntax; ordinary customer input searches product names.
    if(!q||/(^|\s)(title|body|tag|product_type|vendor|variants\.(sku|barcode|title)):/.test(q))return q;
    return q.split(/\s+/u).map(term=>'title:"'+term.replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"').join(' AND ');
  };
  const display=q=>{
    const parts=[...q.matchAll(/title:"((?:\\.|[^"\\])*)"/g)];
    return parts.length&&parts.map(p=>p[0]).join(' AND ')===q?parts.map(p=>p[1].replace(/\\([\\"])/g,'$1')).join(' '):q;
  };
  const normalize=url=>{
    if(url.origin!==location.origin||! /\/search\/?$/.test(url.pathname))return url;
    const type=url.searchParams.get('type');
    if(type&&type!=='product')return url;
    const old=url.searchParams.get('q');if(!old?.trim())return url;
    const next=compile(old);
    if(old!==next)url.searchParams.delete('page');
    url.searchParams.set('q',next);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','none');
    return url;
  };
  window.spotecProductSearch={compile,display,normalize};
  const current=new URL(location.href),canonical=normalize(new URL(current));
  if(canonical.href!==current.href){location.replace(canonical.href);return;}
  document.querySelectorAll('input[type="search"][name="q"]').forEach(input=>input.value=display(input.value));
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(event.defaultPrevented||!(form instanceof HTMLFormElement))return;
    const input=form.querySelector('input[type="search"][name="q"]');if(!input)return;
    const url=new URL(form.action,location.href);
    if(url.origin!==location.origin||! /\/search\/?$/.test(url.pathname))return;
    const data=new FormData(form),type=data.get('type');if(type&&type!=='product')return;
    if(!input.value.trim())return;
    event.preventDefault();url.search=new URLSearchParams(data).toString();location.assign(normalize(url).href);
  });
})();
